import _BaseHttpService from './baseHttp.service'

class ConfigService extends _BaseHttpService {
  constructor () {
    super('config')
  }

  cleanSales (...callbacks) {
    return this.constructor.post(this.constructor._endpoints(this.__key).cleanup, ...callbacks)
  }
}

export default ConfigService
